import { position } from '@approot/models/blotter';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ValueColorsHeapMap'
})
export class ValueColorsHeatMapPipe implements PipeTransform {
  transform(
    value: any,
    minValue: number,
    maxValue: number,
    meanValue: number,
    inverse?: boolean
  ): any {
    const positiveValuesClassNames = ['green1', 'green2', 'green3'];
    const negativeValuesClassNames = ['red1', 'red2', 'red3'];

    if (
      value === '' ||
      value === null ||
      value === undefined ||
      minValue === null ||
      maxValue === null ||
      meanValue === null
    ) {
      return '';
    }
    const normValue = value - meanValue;

    const step =
      normValue > 0 ? (maxValue - meanValue) / 3 : (minValue - meanValue) / 3;

    const index = Math.ceil(normValue / step) - 1;

    if (!inverse) {
      return normValue > 0
        ? negativeValuesClassNames[index] //expensive
        : positiveValuesClassNames[index]; //cheap
    } else {
      return normValue < 0
        ? negativeValuesClassNames[index] //expensive
        : positiveValuesClassNames[index]; //cheap
    }
  }
}
